'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupId$() {
  this.c6Y = null;
  this.c6Z = false;
  this.c6W = null;
  this.c6X = false;
}
export { $c_Lpresto_types$GroupId$ as $c_Lpresto_types$GroupId$ };
$p = $c_Lpresto_types$GroupId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupId$;
/** @constructor */
function $h_Lpresto_types$GroupId$() {
}
export { $h_Lpresto_types$GroupId$ as $h_Lpresto_types$GroupId$ };
$h_Lpresto_types$GroupId$.prototype = $p;
$p.cIc = (function() {
  if ((!this.c6Z)) {
    this.c6Y = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j0;
    this.c6Z = true;
  }
  return this.c6Y;
});
$p.p2 = (function() {
  if ((!this.c6X)) {
    this.c6W = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().dZ;
    this.c6X = true;
  }
  return this.c6W;
});
var $d_Lpresto_types$GroupId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupId$, "presto.types$GroupId$", ({
  a09: 1,
  D: 1
}));
export { $d_Lpresto_types$GroupId$ as $d_Lpresto_types$GroupId$ };
var $n_Lpresto_types$GroupId$;
function $m_Lpresto_types$GroupId$() {
  if ((!$n_Lpresto_types$GroupId$)) {
    $n_Lpresto_types$GroupId$ = new $c_Lpresto_types$GroupId$();
  }
  return $n_Lpresto_types$GroupId$;
}
export { $m_Lpresto_types$GroupId$ as $m_Lpresto_types$GroupId$ };
//# sourceMappingURL=presto.types$-Group-Id$.js.map
